/* ============================================
   DITA LANCIER — Customizer Enhancements
   Supplements customizer.js (loaded after it)
   ============================================ */

/* === HMC Coating Drawer (Step 2: Lens Material) === */
function openHmcDrawer() {
  var overlay = document.getElementById('hmc-overlay');
  var drawer = document.getElementById('hmc-drawer');
  if (overlay) overlay.classList.add('visible');
  if (drawer) drawer.classList.add('visible');
}

function closeHmcDrawer() {
  var overlay = document.getElementById('hmc-overlay');
  var drawer = document.getElementById('hmc-drawer');
  if (drawer) drawer.classList.remove('visible');
  if (overlay) overlay.classList.remove('visible');
}

/* === Lens Material Details Toggle (Step 2) === */
/* Override: preserves underlined styling, swaps text */
function toggleLensDetails(e, btn) {
  e.stopPropagation();
  var ul = btn.parentElement.querySelector('ul');
  if (ul) {
    var isHidden = !ul.classList.contains('show');
    ul.classList.toggle('show', isHidden);
    btn.classList.toggle('open', isHidden);
    var svg = btn.querySelector('svg');
    var svgHtml = svg ? svg.outerHTML : '';
    btn.innerHTML = (isHidden ? 'Hide details ' : 'Details ') + svgHtml;
  }
}

/* === Lancier Add-Ons Button State Manager === */
/* Updates the CTA button text, style, and next-step based on selection state:
   - Nothing selected → ghost button → "CONTINUE WITHOUT ADD-ONS"
   - Engraving only   → solid button → "NEXT: PRESCRIPTION INFORMATION"
   - Transitions (±engraving) → solid button → "NEXT: SELECT LENS COLOR"  */
function updateLancierAddonsButton() {
  var nextBtn = document.getElementById('lancier-addons-next');
  if (!nextBtn) return;

  var engravingSelected = document.getElementById('engraving-card') && document.getElementById('engraving-card').classList.contains('selected');
  var transitionsSelected = document.getElementById('transitions-card') && document.getElementById('transitions-card').classList.contains('selected');

  if (transitionsSelected) {
    // Transitions selected (with or without engraving)
    nextBtn.textContent = 'NEXT: SELECT LENS COLOR';
    nextBtn.dataset.nextStep = 'step-four';
    nextBtn.classList.remove('addons-ghost');
  } else if (engravingSelected) {
    // Only engraving selected
    nextBtn.textContent = 'NEXT: PRESCRIPTION INFORMATION';
    nextBtn.dataset.nextStep = 'step-five';
    nextBtn.classList.remove('addons-ghost');
  } else {
    // Nothing selected
    nextBtn.textContent = 'CONTINUE WITHOUT ADD-ONS';
    nextBtn.dataset.nextStep = 'step-five';
    nextBtn.classList.add('addons-ghost');
  }
}

/* === Add-on Card Toggle (Step 3: Transitions) === */
function toggleAddon(el, e) {
  // Prevent base customizer.js single-option handler from interfering
  if (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
  }

  // Don't toggle if clicking inside engrave-expand
  if (e && e.target.closest('.engrave-expand')) return;

  el.classList.toggle('selected');

  // Clear transitions form values when deselected
  var transCard = document.getElementById('transitions-card');
  if (transCard && !transCard.classList.contains('selected')) {
    var transLensInput = document.querySelector('input[name="properties[Transitions Lens]"]');
    var transVariantInput = document.querySelector('input[name="properties[_transitionsLensVariantId]"]');
    var transPriceInput = document.querySelector('input[name="properties[_transitionsLensVariantPrice]"]');
    if (transLensInput) transLensInput.value = '';
    if (transVariantInput) transVariantInput.value = '';
    if (transPriceInput) transPriceInput.value = '';
  }

  updateLancierAddonsButton();
}

/* === Engraving Card Toggle + Inline Expand (Step 3) === */
function toggleEngraving(el, e) {
  // Prevent base customizer.js single-option handler from interfering
  if (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
  }

  // Don't toggle when clicking inside the expand area (input, etc)
  if (e && e.target.closest('.engrave-expand')) return;

  el.classList.toggle('selected');
  var expand = document.getElementById('engrave-expand');
  var input = document.getElementById('engrave-input');

  // Get engraving variant ID and price from data attributes
  var engravingVariantId = el.dataset.engravingVariantId || '';
  var engravingPrice = el.dataset.engravingPrice || '$50';
  var engravingVariantField = document.querySelector('input[name="properties[_engravingVariantId]"]');

  // Order summary row for engraving (Lancier-only)
  var engRow = document.querySelector('.addon-product .info-row[data-engraving]');
  var engRowTitle = engRow ? engRow.querySelector('h2.title') : null;
  var engRowPrice = engRow ? engRow.querySelector('h5.price') : null;

  if (el.classList.contains('selected')) {
    // Expand
    if (expand) expand.classList.add('visible');
    // Auto-focus input after animation
    if (input) {
      setTimeout(function() { input.focus(); }, 350);
    }
    // Set the engraving variant ID so it gets added to cart
    if (engravingVariantField) engravingVariantField.value = engravingVariantId;
    // Fill the order summary row
    if (engRowTitle) engRowTitle.textContent = 'Custom Laser Engraving';
    if (engRowPrice) engRowPrice.textContent = engravingPrice;
  } else {
    // Collapse and clear
    if (expand) expand.classList.remove('visible');
    if (input) {
      input.value = '';
      // Update counter
      var counter = document.getElementById('engrave-count');
      if (counter) {
        counter.textContent = '0 / 15';
        counter.classList.remove('at-limit');
      }
    }
    // Clear the hidden form fields
    var engravingField = document.querySelector('input[name="properties[Custom Laser Engraving]"]');
    if (engravingField) engravingField.value = '';
    if (engravingVariantField) engravingVariantField.value = '';
    // Clear the order summary row
    if (engRowTitle) engRowTitle.textContent = '';
    if (engRowPrice) engRowPrice.textContent = '';
  }

  // Recalculate subtotal + refresh empty-state / filled classes
  if (typeof window.updateSubTotal === 'function') window.updateSubTotal();

  updateLancierAddonsButton();
}

/* === Engraving Character Counter + Preview === */
function updateEngravePreview(inputEl) {
  var len = inputEl.value.length;
  var counter = document.getElementById('engrave-count');
  if (counter) {
    counter.textContent = len + ' / 15';
    if (len >= 15) {
      counter.classList.add('at-limit');
    } else {
      counter.classList.remove('at-limit');
    }
  }
  // Sync to hidden form field
  var engHidden = document.querySelector('input[name="properties[Custom Laser Engraving]"]');
  if (engHidden) engHidden.value = inputEl.value;
}

/* === DOMContentLoaded: Setup Lancier-specific enhancements === */
document.addEventListener('DOMContentLoaded', function() {
  // Inject "Powered by DITA Lancier" into the initial popup
  // The popup is rendered by main-product-customizer.liquid, so we inject via JS
  var popupContainer = document.querySelector('.show-initial-options');
  if (popupContainer && document.querySelector('.lancier-modal')) {
    var existingPoweredBy = popupContainer.querySelector('.powered-by');
    if (!existingPoweredBy) {
      var poweredByDiv = document.createElement('div');
      poweredByDiv.className = 'powered-by';
      poweredByDiv.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:6px;margin-top:14px;font-family:Merriweather Sans,sans-serif;font-size:9px;text-transform:uppercase;letter-spacing:0.14em;color:#bbb;';
      poweredByDiv.innerHTML = 'Powered by <img src="' + (window.lancierLogoUrl || '') + '" alt="DITA Lancier" style="height:11px;width:auto;vertical-align:middle;opacity:0.6;">';
      popupContainer.appendChild(poweredByDiv);
    }
  }

  // Remove any base customizer.js click handlers from lancier addon cards
  // by re-attaching our own capturing handler that stops propagation
  var lancierAddonCards = document.querySelectorAll('.lancier-addon-card');
  lancierAddonCards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      // Only intercept if this is a lancier addon card
      // The onclick attribute handlers (toggleEngraving, toggleAddon) will fire first
      // This capturing listener prevents the base JS handler from running
      e.stopPropagation();
    }, false);
  });

  // Also handle the engraving input's own event
  var engInput = document.getElementById('engrave-input');
  if (engInput) {
    engInput.addEventListener('input', function() {
      updateEngravePreview(engInput);
      // Clear validation error as user types
      var valMsg = document.getElementById('engrave-validation');
      if (valMsg && engInput.value.trim().length > 0) {
        valMsg.classList.remove('visible');
        engInput.classList.remove('shake');
      }
    });
  }

  // Engraving validation: intercept the add-ons Next button
  var addonsNextBtn = document.getElementById('lancier-addons-next');
  if (addonsNextBtn) {
    addonsNextBtn.addEventListener('click', function(e) {
      var engCard = document.getElementById('engraving-card');
      var engInput = document.getElementById('engrave-input');
      var valMsg = document.getElementById('engrave-validation');

      if (engCard && engCard.classList.contains('selected') && engInput && engInput.value.trim() === '') {
        // Block navigation — show validation message and shake the input
        e.stopImmediatePropagation();
        e.preventDefault();

        if (valMsg) valMsg.classList.add('visible');
        engInput.classList.remove('shake');
        // Re-trigger animation by forcing reflow
        void engInput.offsetWidth;
        engInput.classList.add('shake');
        engInput.focus();
        return false;
      }
    }, true); // useCapture to fire before the base customizer.js handler
  }

  // === DIAGNOSTIC: Log Lancier element state on page load ===
  // NOTE: Engraving and sun lens variants are now added directly in customizer.js
  // checkout handler (same pattern as tint/polarized), no hook needed.
  console.log('[Lancier] Page loaded. Diagnostic:', {
    engravingCardExists: !!document.getElementById('engraving-card'),
    engravingVariantId: document.getElementById('engraving-card') ? document.getElementById('engraving-card').dataset.engravingVariantId : 'no card',
    engravingFromLiquid: window.lancierVariantIds ? window.lancierVariantIds.engraving : 'N/A',
    sunCardCount: document.querySelectorAll('.sun-card').length,
    checkoutBtnCount: document.querySelectorAll('[data-checkout]').length
  });
});

/* === Engraving Sample Photo Toggle (Optical flow: "See example" link) === */
function toggleEngravePhoto(btn) {
  var card = btn.closest('.lancier-addon-card');
  var photo = card ? card.querySelector('.engrave-photo-reveal') : null;
  if (!photo) return;

  var isOpen = photo.classList.contains('open');
  if (isOpen) {
    photo.classList.remove('open');
    btn.classList.remove('active');
    btn.childNodes[0].textContent = 'See example ';
  } else {
    photo.classList.add('open');
    btn.classList.add('active');
    btn.childNodes[0].textContent = 'Hide example ';
  }
}

/* === Sun Lens Card Selection (Step 3 Sun: Land/Sea/Air) === */
function selectSunLens(el) {
  // Deselect all sun cards
  var allCards = document.querySelectorAll('.sun-card');
  allCards.forEach(function(card) {
    card.classList.remove('selected');
  });

  // Select clicked card
  el.classList.add('selected');

  // Update step data
  var step = el.closest('.steps');
  if (step) {
    step.dataset.selectedVariantId = el.dataset.variantId || '';
    step.dataset.price = el.dataset.price || '';
    step.dataset.title = el.dataset.title || '';
  }

  // Update hidden form fields for sun lens
  var sunLensInput = document.querySelector('input[name="properties[Sun Lens]"]');
  var sunVariantInput = document.querySelector('input[name="properties[_sunLensVariantId]"]');
  var sunPriceInput = document.querySelector('input[name="properties[_sunLensVariantPrice]"]');
  if (sunLensInput) sunLensInput.value = el.dataset.title || '';
  if (sunVariantInput) sunVariantInput.value = el.dataset.variantId || '';
  if (sunPriceInput) sunPriceInput.value = el.dataset.price || '';

  // Enable the Next button
  var nextBtn = document.getElementById('sun-next-btn');
  if (nextBtn) nextBtn.disabled = false;

  // Update the sidebar summary
  var addonTitle = document.querySelector('.addon-product .info-row h2.title');
  var addonPrice = document.querySelector('.addon-product .info-row h5.price');
  var addonRow = document.querySelector('.addon-product .info-row');
  if (addonTitle) addonTitle.innerHTML = 'DITA-Lancier ' + (el.dataset.title || '') + ' Lens';
  if (addonPrice) addonPrice.innerHTML = el.dataset.price || '';
  if (addonRow) addonRow.classList.remove('is-hidden');
}
